if (!customElements.get('wls-product-cards')) {
  class WLSProductCards extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        swiperClass: 'js-wls-product-cards-slider',
        prevButton: 'js-swiper-btn-prev',
        nextButton: 'js-swiper-btn-next',
        pagination: 'js-custom-pagination',
        customNavigation: 'js-swiper-navigation',
        productCard: 'wls-product-card',
        preventDragElement: 'js-prevent-drag',
      };

      this.selectors = {
        swiperElement: this.querySelector(`.${this.classes.swiperClass}`),
        prevButton: this.querySelector(`.${this.classes.prevButton}`),
        nextButton: this.querySelector(`.${this.classes.nextButton}`),
        paginationElement: this.querySelector(`.${this.classes.pagination}`),
        customNavigation: this.querySelector(`.${this.classes.customNavigation}`),
        productCards: this.querySelectorAll(`${this.classes.productCard}`),
        preventDragElements: this.querySelectorAll(`${this.classes.preventDragElement}`),
      };

      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     *
     * @returns {void}
     */
    connectedCallback() {
      if (this.selectors.swiperElement) this.initializeSwiper();
      this.initializeDrag();
    }

    /**
     * Initialize Swiper.
     *
     * @returns {void}
     */
    initializeSwiper() {
      this.swiper = new Swiper(this.selectors.swiperElement, {
        loop: true,
        spaceBetween: 8,
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        pagination: {
          el: this.selectors.paginationElement,
          clickable: true,
          renderBullet: (index, className) => {
            return `
                    <span class="${className} slider-dot">
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
                            <path d="M4.4346 1.10409C4.46647 1.05886 4.53353 1.05886 4.5654 1.10409L4.91353 1.59827C5.07491 1.82737 5.37701 1.90831 5.63131 1.7906L6.17989 1.53669C6.2301 1.51345 6.28819 1.54698 6.29317 1.6021L6.34756 2.20413C6.37278 2.48322 6.59393 2.70437 6.87302 2.72959L7.47505 2.78398C7.53016 2.78896 7.5637 2.84704 7.54046 2.89726L7.28654 3.44584C7.16884 3.70014 7.24978 4.00224 7.47887 4.16362L7.97306 4.51175C8.01829 4.54361 8.01829 4.61068 7.97306 4.64255L7.47887 4.99067C7.24978 5.15206 7.16884 5.45415 7.28654 5.70846L7.54046 6.25704C7.5637 6.30725 7.53016 6.36534 7.47505 6.37032L6.87302 6.42471C6.59393 6.44993 6.37278 6.67108 6.34756 6.95017L6.29317 7.5522C6.28819 7.60731 6.2301 7.64085 6.17989 7.6176L5.63131 7.36369C5.37701 7.24598 5.07491 7.32693 4.91353 7.55602L4.5654 8.0502C4.53353 8.09544 4.46647 8.09544 4.4346 8.0502L4.08647 7.55602C3.92509 7.32693 3.62299 7.24599 3.36869 7.36369L2.82011 7.6176C2.7699 7.64085 2.71181 7.60731 2.70683 7.5522L2.65244 6.95017C2.62722 6.67108 2.40607 6.44993 2.12698 6.42471L1.52495 6.37032C1.46984 6.36534 1.4363 6.30725 1.45954 6.25704L1.71346 5.70846C1.83116 5.45415 1.75022 5.15206 1.52113 4.99067L1.02694 4.64255C0.981707 4.61068 0.981707 4.54361 1.02694 4.51175L1.52113 4.16362C1.75022 4.00224 1.83116 3.70014 1.71346 3.44584L1.45954 2.89726C1.4363 2.84704 1.46984 2.78896 1.52495 2.78398L2.12698 2.72959C2.40607 2.70437 2.62722 2.48322 2.65244 2.20413L2.70683 1.60209C2.71181 1.54698 2.7699 1.51345 2.82011 1.53669L3.36869 1.7906C3.62299 1.90831 3.92509 1.82737 4.08647 1.59827L4.4346 1.10409Z" fill="#010101" stroke="#010101" stroke-width="0.5"/>
                        </svg>
                    </span>
                `;
          },
        },
        navigation: {
          prevEl: this.selectors.prevButton,
          nextEl: this.selectors.nextButton,
          enabled: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: {
              enabled: true,
            },
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
              enabled: true,
            },
          },
        },
      });

      if (!this.swiper.isLocked) {
        this.selectors.customNavigation.classList.remove('slider-navigation-lock');
      } else {
        this.selectors.customNavigation.classList.add('slider-navigation-lock');
      }
    }

    /**
     * Initialize drag effect on pack size options.
     */
    initializeDrag() {
      this.selectors.productCards.forEach((productCard) => {
        const preventDragElements = productCard.querySelectorAll(`.${this.classes.preventDragElement}`);
        preventDragElements.forEach((el) => {
          el.addEventListener('mousedown', (e) => {
            this.swiper.allowTouchMove = false;
            this.swiper.navigation.enabled = false;
          });

          el.addEventListener('mouseup', (e) => {
            this.swiper.allowTouchMove = true;
            this.swiper.navigation.enabled = true;
          });

          el.addEventListener('mouseleave', (e) => {
            this.swiper.allowTouchMove = true;
            this.swiper.navigation.enabled = true;
          });

          el.addEventListener('touchstart', (e) => {
            this.swiper.allowTouchMove = false;
            this.swiper.navigation.enabled = false;
          });

          el.addEventListener('touchend', (e) => {
            this.swiper.allowTouchMove = true;
            this.swiper.navigation.enabled = true;
          });

          el.addEventListener('touchcancel', (e) => {
            this.swiper.allowTouchMove = true;
            this.swiper.navigation.enabled = true;
          });
        });
      });
    }
  }

  window.customElements.define('wls-product-cards', WLSProductCards);
}
